import React, { useEffect, useState } from 'react'
import { superAxiosRequest } from 'axiosApi'
import asideModalStore from 'Stores/asideModalStore'
import swal from 'sweetalert'
import st from './Certificates.module.scss'
import PageHeader from 'components/UI/PageHeader/PageHeader'
import { HeaderAddButton } from 'components/UI/SuperButton/SuperButton'
import Pagination from 'components/UI/Pagination/Pagination'
import Loader from 'components/UI/Loader/Loader'
import AddCertificatesModal from './AddCertificatesModal/AddCertificatesModal'
import RowCertificate from './RowCertificate/RowCertificate'
import useLocalization from 'hooks/useLocalization'

const initPagination = {
  page: 1,
  limit: 10,
}

const Certificates = () => {
  const [certificates, setCertificates] = useState(null)
  const [loading, setLoading] = useState(false)
  const [pagination, setPagination] = useState(initPagination)

  const { translate } = useLocalization({
    section: 'groups',
    subsection: 'reports',
    dict: {
      certificates_for_training: 'Certificates for training',
      add_certificate: 'Add certificate',
      certificate_name: 'Certificate name',
      valid_for_days: 'Valid for days',
      certificate_amount: 'Certificate amount',
      edit: 'Edit',
      delete: 'Delete',
      entries: 'Entries',
      name: 'Name',
      serial_number: 'Serial number',
      company: 'Company',
      cancel: 'Cancel',
      save: 'Save',
    },
  })

  const fetchCertificates = () => {
    superAxiosRequest({
      method: 'get',
      link: 'groups/certificates',
      params: {
        offset: (pagination.page - 1) * pagination.limit,
        limit: pagination.limit,
      },
    }).then(({ data }) => {
      setCertificates(data)
      setLoading(false)
    })
  }

  useEffect(() => {
    setLoading(true)
    fetchCertificates()
  }, [pagination])

  const addCertificate = () => {
    const ms = {
      modalBodyComponent: () => <AddCertificatesModal translate={translate} />,
      button: translate.save,
      link: 'groups/certificates',
      title: translate.add_certificate,
      isResponsive: true,
      onSubmitSuccess: () => {
        fetchCertificates()
      },
      valid: {
        name: 'required',
        days_active: 'required',
        amount: 'required',
      },
    }

    asideModalStore.activity(ms, {})
  }

  const editCertificate = (data) => {
    const ms = {
      modalBodyComponent: () => <AddCertificatesModal translate={translate} />,
      button: translate.save,
      link: `groups/certificates/${data?.id}`,
      title: translate.add_certificate,
      isResponsive: true,
      is_put: true,
      onSubmitSuccess: (data) => {
        setCertificates((prev) => {
          return {
            ...prev,
            result: prev.result.map((age) =>
              age.id === data.id ? { ...age, ...data } : age,
            ),
          }
        })
      },
      valid: {
        name: 'required',
        days_active: 'required',
        amount: 'required',
      },
    }
    asideModalStore.activity(ms, data)
  }

  const deleteCertificate = (data) => {
    swal({
      title: 'Are you sure',
      text: 'Are you sure you want to delete the certificate?',
      icon: 'warning',
      buttons: ['No', 'Yes'],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const apiConf = {
          method: 'delete',
          link: `groups/certificates/${data?.id}`,
        }
        superAxiosRequest(apiConf).then(() => {
          setCertificates((prevState) => ({
            ...prevState,
            result: prevState.result.filter((el) => el?.id !== data?.id),
          }))
        })
      }
    })
  }

  const action = (action, e, items) => {
    const actions = new Map([
      ['edit', () => editCertificate(items)],
      ['delete', () => deleteCertificate(items)],
    ])
    return actions.get(action)?.()
  }

  return (
    <div>
      <div className={st.header}>
        <PageHeader title={translate.certificates_for_training}>
          <HeaderAddButton
            title={translate.add_certificate}
            onClick={addCertificate}
          />
        </PageHeader>
      </div>
      {loading ? (
        <Loader />
      ) : (
        <div className={st.conteinerClient}>
          <div className={st.quantityClients}>
            {translate.entries}: {certificates?._meta?.count_items}
          </div>
          <div>
            {certificates?.result?.map((certificate, index) => (
              <RowCertificate
                key={certificate.id}
                certificate={certificate}
                index={index}
                action={action}
                translate={translate}
              />
            ))}
          </div>
        </div>
      )}
      <div className={st.pagination}>
        {certificates?._meta.count_items > 10 && (
          <Pagination
            limit={pagination.limit}
            count={certificates._meta.count_items || 0}
            page={pagination.page}
            onChange={(page) => setPagination({ ...pagination, page })}
            onChangePerPage={(limit) => {
              setPagination({ page: 1, limit })
            }}
          />
        )}
      </div>
    </div>
  )
}

export default Certificates
